import React from "react";
// javascript library that creates a parrallax effect
import Rellax from "rellax";
// reactstrap components
import { Container, 
    Row, 
    Col,
    Card,
    CardBody
    
} from "reactstrap";
// core components

import PresentationHeader from "components/Headers/PresentationHeader2.js";
// sections for this page
// import Politica from "./Politicas/Politicas.js";


function Politicas() {
  React.useEffect(() => {
    document.body.classList.add("presentation-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;

    // initialise Rellax for this page
    if (window.innerWidth >= 991) {
      setTimeout(function () {
        new Rellax(".rellax", {
          center: true,
        });
      }, 5000);
      new Rellax(".rellax-header");
      new Rellax(".rellax-text");
    }

    // we need to add a script for the github buttons
    let script = document.createElement("script");
    script.src = "https://buttons.github.io/buttons.js";
    script.id = "github-buttons-script-id";
    document.body.appendChild(script);

    return function cleanup() {
      document.body.classList.remove("tramites-page");
      document.body.classList.remove("sidebar-collapse");

      // we need to remove the script when we change the page
      script.parentNode.removeChild(script);
    };
  });
  return (
    <>
      <div className="wrapper">
      <PresentationHeader titulo="Políticas de Privacidad y Condiciones de Uso"/>
        <div id= "servicio" style={{backgroundColor: "#f9f9f9"}}>
          <Container className="fluid">
            <Row className="justify-content-center">
              <Col md="6" style={{marginTop:"2%"}}>
                <Card>
                  <CardBody>
                    <center>
                      <a  type="button" href={require("../assets/pdf/Condiciones de Uso.pdf")} style={{borderBottom: "none"}} target="_black">
                        <img
                          alt="PDF Condiciones de Uso"
                          width="80px"
                          src={require("assets/img/Notaria/PDF.png")}
                        ></img>
                        <h5 className="texto"><b>Condiciones de Uso</b></h5>
                      </a>
                    </center>
                  </CardBody>
                </Card>
              </Col>
              <Col md="6" style={{marginTop:"2%"}}>
                <Card>
                  <CardBody>
                    <center>
                      <a  type="button" href={require("../assets/pdf/tratamientodedatos.pdf")} style={{borderBottom: "none"}} target="_black">
                        <img
                          alt="PDF Politica de tratamientos de Datos"
                          width="80px"
                          src={require("assets/img/Notaria/PDF.png")}
                        ></img>
                        <h6  className="texto">Políticas de tratamiento de datos</h6>
                      </a>
                    </center>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
}

export default Politicas;
